var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmilem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 22,
    viewBox: "0 0 95 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_427_455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.324 16.6973C18.324 14.6734 17.2246 13.4793 14.4149 13.3174C11.2135 13.1661 8.02817 12.7737 4.88641 12.1435C1.34376 11.4554 0 9.39098 0 6.98252V6.51702C0 4.04784 1.34376 2.91444 4.88641 3.58234C9.35232 4.50735 13.9049 4.95516 18.4666 4.91812V5.74793C13.9054 5.77497 9.35384 5.32726 4.88641 4.41214C2.03601 3.88592 0.997642 4.89788 0.997642 6.75989V7.24563C0.997642 9.26955 2.09709 10.8077 4.88641 11.2935C8.03323 11.9346 11.2262 12.3271 14.4353 12.4673C17.9779 12.69 19.3217 14.2686 19.3217 16.6569V17.9522C19.3217 20.3606 17.9779 22 14.4353 21.8178C9.72539 21.655 5.05115 20.9418 0.509001 19.6927V18.9034C5.05024 20.1596 9.72454 20.8797 14.4353 21.0488C17.2042 21.2309 18.324 19.8951 18.324 17.9724V16.6973Z",
    fill: "#964E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8306 19.7939V4.25023C41.5143 11.0506 39.3765 14.3698 35.0805 21.1095L34.2254 21.2107C29.9294 15.4425 27.7713 12.5281 23.4753 6.4563V21.9798H22.5591V4.89788H23.5364C27.9952 11.1923 30.2145 14.1674 34.6122 20.2392C39.0711 13.2971 41.2903 9.77552 45.7695 2.71205L46.8283 2.57037V19.6522L45.8306 19.7939Z",
    fill: "#964E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6152 19.1463V2.0239L51.6332 1.90247V19.0046L50.6152 19.1463Z",
    fill: "#964E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4609 18.5188V1.41672L56.4586 1.29529V17.4866C61.4079 16.8141 66.3895 16.402 71.3825 16.2521V17.0414C66.0527 17.2521 60.7379 17.7453 55.4609 18.5188V18.5188Z",
    fill: "#964E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2329 17.1021V-1.28561e-05C79.7008 -0.180609 85.1705 0.301943 90.521 1.43697V2.26678C85.5302 1.21096 80.4339 0.728806 75.3324 0.829794V7.6504C80.2584 7.54953 85.1808 7.98388 90.012 8.94571V9.75528C85.1822 8.7835 80.2587 8.34905 75.3324 8.45997V16.2925C80.4882 16.1791 85.6399 16.6613 90.6838 17.7295V18.5391C85.2833 17.3708 79.7556 16.8879 74.2329 17.1021V17.1021Z",
    fill: "#964E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7783 19.2475V16.1913L94.9999 16.4949V19.5511L93.7783 19.2475Z",
    fill: "#964E7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilem);
export default __webpack_public_path__ + "static/media/smilem.60d1acbb779487cbdee6e99b06864bb9.svg";
export { ForwardRef as ReactComponent };